import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Check } from 'lucide-react';
export function Contact() {
  const [showCopied, setShowCopied] = useState(false);
  const handlePhoneClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Fire Google Ads conversion event
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;
      (window as any).gtag('event', 'conversion', {
        send_to: 'AW-349742034/M8ECCPrSnrADENLH4qYB'
      });
    }
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) {
      e.preventDefault();
      const phoneNumber = '(818) 381-9905';
      navigator.clipboard.writeText(phoneNumber).then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      }).catch(() => {
        window.location.href = 'tel:8183819905';
      });
    }
  };
  return <section className="w-full bg-gradient-to-b from-black to-zinc-950 py-20 px-4" id="contact" data-id="element-41" data-mp="bpcjspop33oi">
      <div className="max-w-5xl mx-auto text-center" data-id="element-42" data-mp="3jvb8iqvtkfdl">
        <h2 className="text-3xl md:text-5xl font-black uppercase text-white mb-2" data-id="element-43" data-mp="3jxnxvp3wps0o">
          Ready for a{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-600" data-id="element-44" data-mp="3owijszx67wp0">
            Showroom Shine?
          </span>
        </h2>
        <p className="text-gray-400 text-lg mb-8" data-id="element-45" data-mp="3f3bdnculwcnv">
          Book your mobile car detailing appointment today — serving Camarillo,
          Thousand Oaks, Simi Valley, Ventura, Agoura Hills, Calabasas Woodland
          Hills & Ventura County
        </p>

        <div className="flex flex-col items-center gap-8" data-id="element-46" data-mp="2s4x0hbahlx9u">
          <a href="tel:8183819905" onClick={handlePhoneClick} className="group relative flex flex-col items-center justify-center w-full max-w-full p-6 sm:p-8 md:p-12 bg-zinc-900 border-2 border-red-600 rounded-2xl hover:bg-zinc-800 transition-all duration-300 shadow-[0_0_40px_-10px_rgba(220,38,38,0.3)] hover:shadow-[0_0_60px_-10px_rgba(220,38,38,0.5)] cursor-pointer" aria-label="Call Mike's Pro Detail" data-id="element-47" data-mp="2s6hvt34mlk8r">
            <span className="text-base sm:text-xl md:text-2xl text-gray-400 uppercase tracking-widest mb-2 font-bold text-center" data-id="element-48" data-mp="2397p5s6fc0kz">
              Call or Text Mike
            </span>
            <div className="flex items-center gap-2 sm:gap-3 md:gap-6" data-id="element-49" data-mp="1ub5rnmlwfq2g">
              <Phone className="w-6 h-6 sm:w-8 sm:h-8 md:w-12 md:h-12 shrink-0 text-red-500 fill-red-500/20" data-id="element-50" data-mp="1pcug97fyh7i4" />
              <span className="text-[28px] sm:text-4xl md:text-6xl lg:text-7xl font-black text-white tracking-tighter whitespace-nowrap group-hover:scale-105 transition-transform" data-id="element-51" data-mp="2m1k196mvqg8b">
                (818) 381-9905
              </span>
            </div>
            <div className="absolute -bottom-4 bg-black px-4 py-1 border border-zinc-800 rounded-full" data-id="element-52" data-mp="28ax1rc9aomb6">
              <span className="text-green-500 font-bold uppercase text-sm flex items-center gap-2" data-id="element-53" data-mp="35psuzl42mu9x">
                <span className="relative flex h-3 w-3" data-id="element-54" data-mp="30zm39ce9itng">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-55" data-mp="30y18pmry7apl"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500" data-id="element-56" data-mp="3d9k96zdb2fii"></span>
                </span>
                Available Now
              </span>
            </div>
          </a>

          {/* Copied to clipboard toast */}
          {showCopied && <div className="fixed top-8 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-4 py-3 bg-green-600 text-white rounded-lg shadow-lg animate-in fade-in slide-in-from-top-2 duration-300" data-id="element-57" data-mp="3mbtdv8lw7enz">
              <Check className="w-5 h-5" data-id="element-58" data-mp="17epmgdk6w4" />
              <span className="font-semibold" data-id="element-59" data-mp="4u0erx0wer1v">
                Phone number copied to clipboard!
              </span>
            </div>}

          {/* Footer navigation: internal + external links */}
          <footer className="mt-12 pt-8 border-t border-zinc-900 w-full text-gray-500 text-sm" data-id="element-60" data-mp="duqaz1u2mjg4">
            <nav aria-label="Footer navigation" data-id="element-61" data-mp="it9wx28nzv8h">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-left mb-8" data-id="element-62" data-mp="iu2updpnbaeh">
              {/* Services */}
              <div data-id="element-63" data-mp="54q1k0aldtdb">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-64" data-mp="157ht7uiboc2">
                  Detailing Services
                </h3>
                <ul className="space-y-2" data-id="element-65" data-mp="evay7i6pgntl">
                  <li data-id="element-66" data-mp="eygq156py3t0">
                    <Link to="/services/mobile-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-67" data-mp="9x1295d5pj6x">
                      Mobile Detailing
                    </Link>
                  </li>
                  <li data-id="element-68" data-mp="3ec97chm9aj5r">
                    <Link to="/services/interior-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-69" data-mp="3ecsnptw9czho">
                      Interior Detailing
                    </Link>
                  </li>
                  <li data-id="element-70" data-mp="3nbnxth2fatq9">
                    <Link to="/services/exterior-detailing" className="hover:text-yellow-400 transition-colors" data-id="element-71" data-mp="3nb4ebvx4jxa4">
                      Exterior Detailing
                    </Link>
                  </li>
                  <li data-id="element-72" data-mp="12oayzbnx387z">
                    <Link to="/services/full-car-detail" className="hover:text-yellow-400 transition-colors" data-id="element-73" data-mp="2kjthwgpy80y4">
                      Full Car Detail
                    </Link>
                  </li>
                  <li data-id="element-74" data-mp="2bj53vm0k20l8">
                    <Link to="/services/ceramic-coating" className="hover:text-yellow-400 transition-colors" data-id="element-75" data-mp="2bjooxbli553h">
                      Ceramic Coating
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Service areas */}
              <div data-id="element-76" data-mp="389ecjwvgsmn8">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-77" data-mp="389xief7ubkkw">
                  Service Areas
                </h3>
                <ul className="space-y-2" data-id="element-78" data-mp="2uhr3sxkc5lnk">
                  <li data-id="element-79" data-mp="2zgubkprpa5z8">
                    <Link to="/ventura-county/camarillo" className="hover:text-yellow-400 transition-colors" data-id="element-80" data-mp="2zg2dn8amrw5s">
                      Camarillo
                    </Link>
                  </li>
                  <li data-id="element-81" data-mp="3rxn4c5t3iqm7">
                    <Link to="/ventura-county/oxnard" className="hover:text-yellow-400 transition-colors" data-id="element-82" data-mp="3ry6kpi33l6y4">
                      Oxnard
                    </Link>
                  </li>
                  <li data-id="element-83" data-mp="py29hn2djju">
                    <Link to="/ventura-county/ventura" className="hover:text-yellow-400 transition-colors" data-id="element-84" data-mp="pfz011zi52f">
                      Ventura
                    </Link>
                  </li>
                  <li data-id="element-85" data-mp="3mvbewjgh0u18">
                    <Link to="/ventura-county/thousand-oaks" className="hover:text-yellow-400 transition-colors" data-id="element-86" data-mp="3my7dma057mqq">
                      Thousand Oaks
                    </Link>
                  </li>
                  <li data-id="element-87" data-mp="3e1pyywskl6q8">
                    <Link to="/ventura-county/simi-valley" className="hover:text-yellow-400 transition-colors" data-id="element-88" data-mp="394pv8sj70g2a">
                      Simi Valley
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Find us online (external links) */}
              <div data-id="element-89" data-mp="2z8d0rsftpy6h">
                <h3 className="text-white font-bold uppercase tracking-wider text-xs mb-3" data-id="element-90" data-mp="2v56uikspo700">
                  Find Us Online
                </h3>
                <ul className="space-y-2" data-id="element-91" data-mp="1amcu7dpe3wlc">
                  <li data-id="element-92" data-mp="1eo7wolj24g0p">
                    <a href="https://www.google.com/maps/search/Mike%27s+Pro+Detail+Ventura+County" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors" data-id="element-93" data-mp="1enq2rvjvadvy">
                      Google Maps &amp; Reviews
                    </a>
                  </li>
                  <li data-id="element-94" data-mp="qzf6l5p492e0">
                    <a href="https://www.bbb.org/search?find_text=Mike%27s+Pro+Detail&find_loc=Ventura+County%2C+CA" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors" data-id="element-95" data-mp="r086pntkktn6">
                      Better Business Bureau
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            </nav>

            <div className="pt-6 border-t border-zinc-900 flex flex-col md:flex-row justify-between items-center gap-2 text-gray-600" data-id="element-96" data-mp="897a36fx9a6s">
              <p data-id="element-97" data-mp="d5xm9iolvlmx">
                © {new Date().getFullYear()} Mike's Pro Detail — Mobile Car
                Detailing Ventura County &amp; San Fernando Valley. All rights
                reserved.
              </p>
              <p data-id="element-98" data-mp="2xskc28ixg216">
                <a href="/#services" className="hover:text-gray-400 transition-colors" data-id="element-99" data-mp="3bq8vrd19d34n">
                  Services
                </a>
                {' · '}
                <a href="/#service-areas" className="hover:text-gray-400 transition-colors" data-id="element-100" data-mp="36pm9nzrsshtu">
                  Service Areas
                </a>
                {' · '}
                <Link to="/faq" className="hover:text-gray-400 transition-colors" data-id="element-101" data-mp="3gq4yza24sqj5">
                  FAQ
                </Link>
              </p>
            </div>
          </footer>
        </div>
      </div>
    </section>;
}